// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-slider {
  position: relative;
  width: 100%;
  height: 14px;
  padding: 15px 0;
  border-radius: 6px;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.rc-slider .rc-slider-rail {
  position: absolute;
  width: 100%;
  height: 8px !important;
  border-radius: 90px;
  background: var(--escala-de-grises-gris-200, #E8EAED);
}
.rc-slider .rc-slider-track {
  position: absolute;
  height: 8px;
  background-color: #2D7AC7;
  border-radius: 6px;
}
.rc-slider .rc-slider-handle {
  position: absolute;
  z-index: 1;
  width: 32px;
  height: 32px;
  margin-top: -11px;
  background-color: #005CB9;
  border: solid 7px #FFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.17);
  border-radius: 50%;
  cursor: pointer;
  cursor: -webkit-grab;
  cursor: grab;
  opacity: 1;
  touch-action: pan-x;
}
.rc-slider .rc-slider-handle.rc-slider-handle-dragging {
  border-color: #FFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.17);
}

.container_form__money {
  color: var(--color-secundario-azul-900, #00376F);
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.container_form__money-description {
  color: #00254A;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.alert_message {
  display: flex;
  width: 100%;
  padding: 16px;
  align-items: flex-start;
  gap: 8px;
  background: var(--escala-de-grises-gris-100-fondo, #F7F7F7);
  height: 92px;
  margin-top: 24px;
}
.alert_message p {
  color: var(--escala-de-grises-gris-color-de-texto, #363A44);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/use-account-management/use/style.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6CAAA;AACJ;AAAK;EACG,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,qDAAA;AAER;AAAI;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAER;AAAI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAER;AADQ;EACI,kBAAA;EACA,2CAAA;AAGZ;;AAEA;EACI,gDAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;;AAGA;EACI,aAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,2DAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AACI;EACI,2DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACR","sourcesContent":[".rc-slider {\n    position: relative;\n    width: 100%;\n    height: 14px;\n    padding: 15px 0;\n    border-radius: 6px;\n    touch-action: none;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n     .rc-slider-rail {\n        position: absolute;\n        width: 100%;\n        height: 8px !important;\n        border-radius: 90px;\n        background: var(--escala-de-grises-gris-200, #E8EAED);\n    }\n    .rc-slider-track {\n        position: absolute;\n        height: 8px;\n        background-color: #2D7AC7;\n        border-radius: 6px;\n    }    \n    .rc-slider-handle{\n        position: absolute;\n        z-index: 1;\n        width: 32px;\n        height: 32px;\n        margin-top: -11px;\n        background-color: #005CB9;\n        border: solid 7px #FFF;\n        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.17) ;\n        border-radius: 50%;\n        cursor: pointer;\n        cursor: -webkit-grab;\n        cursor: grab;\n        opacity: 1;\n        touch-action: pan-x;\n        &.rc-slider-handle-dragging {\n            border-color: #FFF;\n            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.17) ;  \n        }\n    }\n}\n\n.container_form__money {\n    color: var(--color-secundario-azul-900, #00376F);\n    font-family: Roboto;\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.container_form__money-description{\n    color: #00254A;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n}\n\n\n.alert_message {\n    display: flex;\n    width: 100%;\n    padding: 16px;\n    align-items: flex-start;\n    gap: 8px;\n    background: var(--escala-de-grises-gris-100-fondo, #F7F7F7);\n    height: 92px;\n    margin-top: 24px;\n    p {\n        color: var(--escala-de-grises-gris-color-de-texto, #363A44);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px; \n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
